/* Status Bar - vim/tmux style */
.statusBar {
  position: relative;
  flex-shrink: 0;
  height: 40px;
  background: var(--color-surface);
  border-bottom: var(--border-thin) var(--border-style) var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--space-4);
  font-family: var(--font-mono);
  font-size: var(--caption-size);
  z-index: 100;
}

.statusLeft {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.menuIcon {
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
}

.menuIcon svg {
  width: 16px;
  height: 16px;
}

.activeApp {
  color: var(--color-text-muted);
  font-weight: 600;
}

.statusRight {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

.themeToggle {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: var(--space-1);
  color: var(--color-text-muted);
  transition: color var(--transition-fast);
}

.themeToggle svg {
  width: 16px;
  height: 16px;
}

.themeToggle:hover {
  color: var(--color-text);
}

.statusTime {
  color: var(--color-text-subtle);
  min-width: 50px;
}
